import DashboardNoticeList from "./DashboardNoticeList";

export default DashboardNoticeList;